import React, {Component} from 'react';
import * as Products from '../../../libraries/Products.js';
import QuantityDiscount from './QuantityDiscount';

class Retail extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  };

  render() {
    let variant = Products.getVariantByVariantID(this.props.data.variant_id);
    let compare_price = null;
    if( variant!==null ){
      compare_price = variant.compare_at_price ?? null;
      if( compare_price!==null ) compare_price = parseFloat( parseFloat(compare_price).toFixed(2) );
    }

    return (
      <div className="price_container px-1">
        <React.Fragment>
          {(() => {
            if (this.props.data.final_price===0) {
              return (
                <span className="price">(Free)</span>
              )
            }
            else return <span className="price">${compare_price*this.props.data.quantity}</span>
          })()}
          <QuantityDiscount 
            data={this.props.data}
            properties={this.props.data.properties}
          />
        </React.Fragment>
      </div>
    )
  };
}
export default Retail;